module.exports = __webpack_public_path__ + "img/denmark-ill-defined-causes-female.0859ba03.png";